import { ATTACHMENT_MAX_BYTES, type AttachmentDTO } from '@wd/shared';
import { ApiError } from './api';

// 上传附件：请求体直接是文件内容（服务端的写接口只收 JSON，上传靠 x-wd-upload 请求头放行）

export const attachmentUrl = (id: string) => `/api/attachments/${id}`;

export const isImage = (mime: string) => /^image\/(png|jpeg|gif|webp)$/.test(mime);

export function fmtSize(n: number) {
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${Math.round(n / 1024)} KB`;
  return `${(n / 1024 / 1024).toFixed(1)} MB`;
}

/** 上传一个文件；onProgress 收到 0–100 的进度（大文件上传要一会儿） */
export function uploadFile(file: File, reportItemId?: string, onProgress?: (pct: number) => void): Promise<AttachmentDTO> {
  if (file.size > ATTACHMENT_MAX_BYTES) {
    return Promise.reject(new ApiError(413, `「${file.name}」超过 ${Math.round(ATTACHMENT_MAX_BYTES / 1024 / 1024)} MB，传不上去`));
  }
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open('POST', `/api/attachments${reportItemId ? `?reportItemId=${encodeURIComponent(reportItemId)}` : ''}`);
    xhr.withCredentials = true;
    xhr.setRequestHeader('content-type', file.type || 'application/octet-stream');
    xhr.setRequestHeader('x-wd-upload', '1');
    xhr.setRequestHeader('x-file-name', encodeURIComponent(file.name));
    xhr.upload.onprogress = (e) => e.lengthComputable && onProgress?.(Math.min(99, Math.round((e.loaded / e.total) * 100)));
    xhr.onload = () => {
      let data: unknown = {};
      try {
        data = JSON.parse(xhr.responseText);
      } catch {
        /* 非 JSON 响应按失败处理 */
      }
      if (xhr.status >= 200 && xhr.status < 300) {
        onProgress?.(100);
        resolve(data as AttachmentDTO);
      } else if (xhr.status === 401) {
        location.assign(`/login?next=${encodeURIComponent(location.pathname)}`);
        reject(new ApiError(401, '请先登录'));
      } else reject(new ApiError(xhr.status, (data as { error?: string }).error ?? `「${file.name}」没传上去，请再试一次`));
    };
    xhr.onerror = () => reject(new ApiError(0, `网络断了，「${file.name}」没传上去`));
    xhr.send(file);
  });
}
